import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Example1 from 'pages/example/Example1';
import Example2 from '../pages/example/Example2';
import SystemRouter from './home/SystemRouter';
import ChatHistoryRouter from './home/ChatHistoryRouter';
import RecommendRouter from './home/RecommendRouter';
import ProjectRouter from './home/ProjectRouter';
import QuestionRouter from './home/QuestionRouter';
import CardRouter from './home/CardRouter';
import ChangePasswordRouter from './home/ChangePasswordRouter';
import SurveyRouter from './home/SurveyRouter';
import ChargingRouter from './home/ChargingRouter';

const HomeRouter = () => {
  return (
    <Routes>
      <Route path="/example/example1" element={<Example1 />}></Route>
      <Route path="/example/example2" element={<Example2 />}></Route>
      <Route path="/System/*" element={<SystemRouter />}></Route>
      <Route path="/ChatHistory/*" element={<ChatHistoryRouter />}></Route>
      <Route path="/Recommend/*" element={<RecommendRouter />}></Route>
      <Route path="/Project/*" element={<ProjectRouter />}></Route>
      <Route path="/Question/*" element={<QuestionRouter />}></Route>
      <Route path="/Card/*" element={<CardRouter />}></Route>
      <Route path="/Survey/*" element={<SurveyRouter />}></Route>
      <Route path="/Charging/*" element={<ChargingRouter />}></Route>
      <Route
        path="/ChangePassword/*"
        element={<ChangePasswordRouter />}></Route>
    </Routes>
  );
};

export default HomeRouter;
